import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../contexts/AppContextProvider";

export function BuildTime() {
    const [state, setState] = useState({ className: "", buildTime: "" });
    const { config } = useContext(AppContext);

    useEffect(() => {
        const envClass = config.environment === "production" ? "" : "transparent";

        const time = new Date(config.buildTime);
        setState({
            className: envClass,
            buildTime: "Build Time: " + moment(time).format("M/D/YY h:mm A"),
        });
    }, []);

    return <div className={state.className}>{state.buildTime}</div>;
}
